import { Percent, TrendingUp, Clock } from "lucide-react";

const stats = [
  {
    icon: <Percent className="w-8 h-8 text-brand-primary" />,
    bgColor: "bg-blue-100",
    title: "93% de Ocupación",
    description: "Nuestras propiedades tienen una tasa de ocupación superior.",
  },
  {
    icon: <TrendingUp className="w-8 h-8 text-green-600" />,
    bgColor: "bg-green-100",
    title: "Más Ingresos",
    description: "Optimizamos precios para maximizar tus ganancias",
  },
  {
    icon: <Clock className="w-8 h-8 text-purple-600" />,
    bgColor: "bg-purple-100",
    title: "24/7 Disponible",
    description: "Atención completa para huéspedes y propietarios",
  },
];

const PropertyManagementStats = () => (
  <section className="py-16 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {stats.map(({ icon, bgColor, title, description }) => (
          <div key={title} className="text-center">
            <div
              className={`inline-flex items-center justify-center w-16 h-16 ${bgColor} rounded-full mb-4`}
            >
              {icon}
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-2">{title}</h3>
            <p className="text-gray-600">{description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default PropertyManagementStats;
